import {gsap} from "../../lib/gsap";

export default class BlockGallerySlider {
	static init() {
		let blocks = document.querySelectorAll('.block-gallery-slider');

		blocks.forEach( (block) => {
			const swipers = block.querySelectorAll(".block-gallery-swiper");
			swipers.forEach( (stage) => {
				const inner = block.querySelector(".inner");
				const prev = block.querySelector(".gallery-button-prev");
				const next = block.querySelector(".gallery-button-next");
				const navigation = block.querySelector('.swiper-navigation');
				const arrows = block.querySelector(".swiper-swipe-indicator");
				let swiper = new Swiper(stage, {
					slidesPerView: (stage.classList.contains('gallery-fixed-width')) ? 1 : "auto",
					grabCursor: true,
					touchEventsTarget: "container",
					mousewheel: {
						enabled: true,
						releaseOnEdges: true,
						forceToAxis: true,
					},
					navigation: {
						prevEl: prev,
						nextEl: next
					},
					pagination: {
						el: navigation,
						type: 'bullets',
						bulletElement: 'span',
						clickable: true
					},
					on:{
						touchStart: () => {
							if( arrows ) {
								gsap.to(arrows, 0.2, {
									scale: 0.2
								});
							}
						},
						touchMove: (swiper, e) => {
							if( arrows ) {
								let sliderOffset = stage.getBoundingClientRect();
								gsap.to(arrows, 0.3, {
									top: e.clientY - sliderOffset.top,
									left: e.clientX - sliderOffset.left
								});
							}
						},
						touchEnd: () => {
							if( arrows ) {
								gsap.to(arrows, 0.2, {
									scale: 1
								});
							}
						},
						lock: () => {
							stage.classList.remove("swiper-is-active");
						},
						unlock: () => {
							stage.classList.add("swiper-is-active");
						},
						resize: (swiper) => {
							if( arrows ) {
								arrows.classList.toggle("hidden", swiper.isEnd);
							}
						}
					}
				});

				if( arrows ) {

					swiper.slides.forEach((slide) => {
						slide.querySelectorAll('a').forEach((link) => {
							link.addEventListener("mouseenter", () => {
								gsap.to(arrows, 0.2, {
									scale: 0.2,
									opacity: 0
								});
							});
							link.addEventListener("mouseleave", () => {
								gsap.to(arrows, 0.2, {
									scale: 1,
									opacity: 1
								});
							});
						});
					});

					stage.addEventListener("mouseenter", (e) => {
						let sliderOffset = inner.getBoundingClientRect();
						gsap.to(arrows, 0.2, {
							scale: 1
						});
						gsap.set(arrows, {
							top: e.clientY - sliderOffset.top,
							left: e.clientX - sliderOffset.left,
						});
					});

					stage.addEventListener("mousemove", (e) => {
						let sliderOffset = inner.getBoundingClientRect();
						gsap.to(arrows, 0.3, {
							top: e.clientY - sliderOffset.top,
							left: e.clientX - sliderOffset.left
						});
					});

					stage.addEventListener("mouseleave", () => {
						gsap.to(arrows, 0.2, {
							scale: 0,
							overwrite: true
						});
					});

				}
			});

		});
	}
}
